// removed by extract-text-webpack-plugin
module.exports = {"button":"_13-p4","page":"l0jC7","heading":"_1qE1A","queue":"BXD4-","name":"_1BI8W","info":"_7PNLO","playlist":"JiGBM"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Queues.css
// module id = 863
// module chunks = 0